import { createContext, useContext } from 'react'

interface AIChatSupportContextProps {
   onCloseChat: () => void
}

export const AIChatSupportContext = createContext<AIChatSupportContextProps | null>(
   null
)

export const useAIChatSupportContext = (): AIChatSupportContextProps => {
   const context = useContext(AIChatSupportContext)

   if (!context) {
      throw new Error(
         'Expected to be wrapped with AIChatSupportContext Provider'
      )
   }

   return context
}
